import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sl_market_mem",
  "use": "icon-sl_market_mem-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sl_market_mem\"><path d=\"M41 4H7C5.34315 4 4 5.34315 4 7V41C4 42.6569 5.34315 44 7 44H41C42.6569 44 44 42.6569 44 41V7C44 5.34315 42.6569 4 41 4Z\" fill=\"none\" stroke=\"#585858\" stroke-width=\"3\" stroke-linejoin=\"bevel\" /><path d=\"M34 4V22H15V4H34Z\" fill=\"none\" stroke=\"#585858\" stroke-width=\"3\" stroke-linejoin=\"bevel\" /><path d=\"M29 11V15\" stroke=\"#585858\" stroke-width=\"3\" stroke-linecap=\"round\" /><path d=\"M11.9968 4H36.9984\" stroke=\"#585858\" stroke-width=\"3\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sl_market_mem.svg
// module id = 7/kE
// module chunks = 102